module.exports = {
          srcSet: __webpack_public_path__ + "ef4d594dddbbfed8867503689c95a726-445.png"+" 445w",
          images:[ {path: __webpack_public_path__ + "ef4d594dddbbfed8867503689c95a726-445.png",width: 445,height: 871}],
          src: __webpack_public_path__ + "ef4d594dddbbfed8867503689c95a726-445.png",
          toString:function(){return __webpack_public_path__ + "ef4d594dddbbfed8867503689c95a726-445.png"},
          
          width: 445,
          height: 871
        }